<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.promotion.support' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__checkbox" aria-invalid="false">
          <legend class="p-support-info__checkbox-legend" [innerHTML]="'label.promotion.support' | staticMsg"></legend>
          <div class="p-support-info__checkbox-list">
            <!--歩行に不自由がある-->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="support-information-input-special-assistance-checkbox1_1"
                class="p-support-info__checkbox-item-input"
                (change)="changeDegreeOfWalking()"
                [(ngModel)]="degreeOfWalking"
              />
              <label
                for="support-information-input-special-assistance-checkbox1_1"
                class="p-support-info__checkbox-item-label"
              >
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span
                    class="p-support-info__checkbox-item-text"
                    [innerHTML]="'label.degreeOfWalking' | staticMsg"
                  ></span>
                </span>
              </label>
            </div>
            <!--視力に不自由がある-->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="support-information-input-special-assistance-checkbox1_2"
                class="p-support-info__checkbox-item-input"
                [(ngModel)]="blind"
              />
              <label
                for="support-information-input-special-assistance-checkbox1_2"
                class="p-support-info__checkbox-item-label"
              >
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span class="p-support-info__checkbox-item-text" [innerHTML]="'label.blind' | staticMsg"></span>
                </span>
              </label>
            </div>
            <!--聴力に不自由がある-->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="support-information-input-special-assistance-checkbox1_3"
                class="p-support-info__checkbox-item-input"
                [(ngModel)]="deaf"
              />
              <label
                for="support-information-input-special-assistance-checkbox1_3"
                class="p-support-info__checkbox-item-label"
              >
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span class="p-support-info__checkbox-item-text" [innerHTML]="'label.deaf' | staticMsg"></span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <!--<div style="height: 2000px;"></div>-->
</div>
